export default __webpack_public_path__ + "static/media/ig.928f93fa.png";